import React, { useEffect } from 'react';
import {
  Box,
  Text,
  Stack,
  Flex,
  Image,
  Center,
  Spinner,
  Icon,
  Progress,
  Button,
} from '@chakra-ui/react';
import ReactGA from 'react-ga';
import NumberFormat from 'react-number-format';
import { useHistory } from 'react-router-dom';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { useUserOwnedVestingInfo, getAddrState, useStreamInfo } from '../../api/query';

import { tokenMap } from '../../config/constants';
import Panel from '../../components/panel';
import userStore from '../../stores/account';
// import {

// } from '../../api/contracts';
// import { useAssetsQuery } from '../../api/query';

const Page = () => {
  const address = getAddrState();
  return <Box textAlign="center">add</Box>;
};

export default Page;
